import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  title: String,
  content: String
}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<DialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
    this.CheckLoggedOut();
  }

  CheckLoggedOut() {
    let check = true;
    setInterval(function () {
      const loginTime = localStorage.getItem('loginTime');
      if (loginTime === null) {
        check = false;
      }
      if (check && typeof (Storage) !== 'undefined') {
        const currentTime = new Date().getTime();
        // logout after 30 minutes of login.
        if (((currentTime - +loginTime)) > (60 * 240 * 1000)) {
          window.location.href = window.location.origin;
          check = false;
        }
      }
    }, 1000 * 60); // 60 * 1000 milsec
  }
}
